module.exports = __webpack_public_path__ + "/static/assets/82cce6491c05a89e33c200dfd2df4edd.png";